<template lang="pug">
  transition(name="overlay")
    .overlay(v-if="isOpen" :class="{ 'content-centered': centered }")
      a(href="#", title="close" @click.prevent="$emit('update:isOpen', false)" class="overlay-close") #[AppIcon(name='close')]
      .overlay-body
        .container
          slot
</template>

<script>
export default {
  name: 'Overlay',
  props: {
    isOpen: {
      type: null,
      required: true
    },
    centered: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    isOpen(value) {
      document.body.classList[value ? 'add' : 'remove']('is-scroll-disabled');
    },
    $route() {
      document.body.classList.remove('is-scroll-disabled');
    }
  },
  beforeDestroy() {
    document.body.classList.remove('is-scroll-disabled');
  }
};
</script>

<style lang="stylus" scoped>
.overlay
  &.content-centered
    .overlay-body
      height: 100%
      align-items: center
      justify-content: center
      display: flex
    .container
      align-self: center
</style>
